<template>
  <div class="password-reset">
    <div class="reset-container">
      <div class="reset-content">
        <div class="reset-form">
          <div class="logo"><img src="/assets/img/logo.png" /></div>
          <div class="title">DRIVER PASSWORD RESET</div>

          <div :class="{ 'error-message': true, show: error.show }">{{ error.message }}</div>
          <!-- <input type="text" v-model="email" readonly> -->
          <input type="password" v-model="password" placeholder="New Password" :class="{'disabled':formLoading}">
          <input type="password" v-model="repeatPassword" placeholder="Repeat Password" :class="{'disabled':formLoading}">

          <div class="button cta success block update-button" @click="updatePassword">
            <span v-if="!formLoading">Update Password</span>
            <span v-else>
              <i class="fas fa-circle-notch fa-spin"></i>
              Loading...
            </span>
          </div>
        </div>
      </div>
    </div>

    <loading-modal :showModal="loading" modalMessage="Loading..."></loading-modal>

    <div v-bind:class="{ 'modal':true, 'show':showModal }" @click="close">
      <div class="modal-container">
        <div class="modal-content" @click.stop>
          <label>Success!</label>
          <p>
            Your password has been changed successfully.<br />
            You may now use your new password to login.
          </p>
          <div class="button cta small block" @click="close">Close</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import loadingModal from '@/components/Partials/LoadingModal'
export default {
  name: 'password-reset-driver',
  components: { loadingModal },
  data () {
    return {
      loading: false,
      showForm: false,
      email: '',
      password: '',
      repeatPassword: '',
      formLoading: false,
      error: {
        show: false,
        message: ''
      },
      showModal: false
    }
  },
  methods: {
    updatePassword () {
      let self = this
      self.error = { show: false, message: '' }
      if (self.password.trim() === '' || self.repeatPassword.trim() === '') {
        self.error = {
          show: true,
          message: 'Fields cannot be empty.'
        }
        return
      }
      if (self.password !== self.repeatPassword) {
        self.error = {
          show: true,
          message: 'Password and Repeat password doesnt match.'
        }
        return
      }
      self.formLoading = true
      self.showModal = false
      let key = this.$route.query.token
      self.$sdk.post('/drive/password', { key: key, password: self.password }, r => {
        self.formLoading = false
        self.showModal = true
      })
    },
    close () { this.$router.push('/login') }
  },
  mounted () {
    let self = this
    self.$store.commit('sideMenu/hideMenuButton')
  },
  destroyed () {
    this.$store.commit('sideMenu/showMenuButton')
  }
}
</script>

<style lang="scss" scoped>
.password-reset{
  background-color: #292931;
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.reset-container{
  display: table;
  width: 100%;
  height: 100%;
}
.reset-content{
  display: table-cell;
  vertical-align: middle;
  position: relative;
}
.reset-form{
  width: 350px;
  margin: 0 auto;
  background-color: #423142;
  box-shadow: 0 3px 8px rgba(0,0,0,0.5);
  border-radius: 3px;
  padding: 50px 20px 20px;
  position: relative;
  .title {
    color: #fff;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    margin: 10px 0;
  }
  .logo {
    width: 120px;
    height: 120px;
    left: calc(50% - 60px);
    display: block;
    position: absolute;
    position: absolute;
    top: -70px;
    background-color: #423142;
    border-radius: 100%;
  }
  img {
    width: 100px;
    height: 100px;
    margin: 10px;
    display: block;
  }
  input[readonly], input.disabled{
    background: #ddd;
    color: #777;
  }
}
.update-button{
  margin-top: 15px;
}
.error-message {
  background-color: #F20D0D;
  text-align: center;
  color: #fff;
  padding: 0px 10px;
  font-size: 12px;
  border-radius: 3px;
  margin-bottom: 0;
  height: 0;
  transition: all 250ms;
  overflow: hidden;
  &.show{
    height: 28px;
    padding: 5px 10px;
    margin-bottom: 10px;
  }
}
.modal {
  position: fixed;
  z-index: 999;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
  display: table;
  opacity: 0;
  transition: all 250ms;
  &.show{
    top: 0;
    opacity: 1;
  }
}
.modal-container {
  display: table-cell;
  vertical-align: middle;
}
.modal-content {
  background-color: #fff;
  border-radius: 3px;
  max-width: 380px;
  margin: 0 auto;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  text-align: center;
  overflow: hidden;
  padding: 25px;
  label{
    font-size: 21px;
    font-weight: 600;
    margin-bottom: 20px;
    display: block;
  }
  p{
    margin: 0;
    font-size: 14px;
    color: #444;
  }
  b{ font-size: 15px; }
  .button{
    margin-top: 25px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/App/PasswordResetDriver.vue